 var TAimagegrid = (function($) {
    'use strict';

    function init() {
        events();
    }
    

    function events() {

        // Wait for ScrollTrigger to be ready and check window width
        if (typeof ScrollTrigger !== 'undefined' && window.innerWidth >= 1280) {
            const imageGrids = document.querySelectorAll('.wrapper__images-sidebyside');
            
            // Pre-initialize all elements with GPU acceleration
            gsap.set('.image__large, .image__small', {
                force3D: true
            });
            
            imageGrids.forEach(grid => {
                const largeImage = grid.querySelector('.image__large');
                const smallImage = grid.querySelector('.image__small');
                
                if (largeImage && smallImage) {
                    // Set initial positions
                    gsap.set(largeImage, { y: -25 });
                    gsap.set(smallImage, { y: 25 });

                    // Create timeline for synchronized animations
                    const tl = gsap.timeline({
                        scrollTrigger: {
                            trigger: grid,
                            start: 'top bottom',
                            end: 'bottom top',
                            scrub: 1,
                        }
                    });

                    // Add both animations to the timeline, starting from their offset positions
                    tl.to(largeImage, {
                        y: 25,
                        ease: 'none',
                        force3D: true
                    }, 0)
                    .to(smallImage, {
                        y: -25,
                        ease: 'none',
                        force3D: true
                    }, 0);
                }
            });

            // Force a refresh after setup
            requestAnimationFrame(() => {
                ScrollTrigger.refresh();
            });

            // Handle resize events
            window.addEventListener('resize', function() {
                if (window.innerWidth < 1280) {
                    // Reset positions if screen becomes smaller
                    document.querySelectorAll('.image__large, .image__small').forEach(img => {
                        gsap.set(img, { y: 0 });
                    });
                    ScrollTrigger.getAll().forEach(trigger => trigger.kill());
                }
            });
        } else {
            console.log('ScrollTrigger is undefined or screen width < 1280px');
        }
    }

    return {
        init: init
    };
}(jQuery));
